// extracted by mini-css-extract-plugin
export default {"Carousel":"Carousel__Carousel___STrgV","centered":"Carousel__centered___wOOTf","dots":"Carousel__dots___mIxF6"};